import { ReleaseTypeEnum } from './enums.js';

const UPLOAD_STEP_NAMES = {
  RELEASE_INFO: "Release Info",
  ALBUM_INFO: "Album Info",
  METADATA: "Metadata",
  REWARDS: "Rewards",
  AUCTION_CONFIGURATION: "Auction Configuration",
  SPLITS: "Splits",
  REVIEW_AND_DEPLOY: "Review and Deploy"
};
const DRAFT_UPDATE_FAILED_DUP_TITLE_MESSAGE = (title) => `Draft with title ${title} already exists.`;
const FREE_SALE_MAX_MINTS_PER_WALLET_OPTIONS = [1];
const MIN_PRESALE_MAX_MINTS_PER_WALLET = 1;
const MAX_PRESALE_MAX_MINTS_PER_WALLET = 100;
const PRESALE_MAX_MINTS_PER_WALLET_OPTIONS = [
  MIN_PRESALE_MAX_MINTS_PER_WALLET,
  3,
  5,
  10,
  25,
  50,
  MAX_PRESALE_MAX_MINTS_PER_WALLET
];
const MIN_PUBLIC_SALE_MAX_MINTS_PER_WALLET = 1;
const MAX_PUBLIC_SALE_MAX_MINTS_PER_WALLET = 100;
const PUBLIC_SALE_MAX_MINTS_PER_WALLET_OPTIONS = [
  MIN_PUBLIC_SALE_MAX_MINTS_PER_WALLET,
  3,
  5,
  10,
  25,
  50,
  MAX_PUBLIC_SALE_MAX_MINTS_PER_WALLET
];
const OPEN_EDITION_MAX_MINTS_PER_WALLET_OPTIONS = [1e4];
const PRESALE_OPEN_EDITION_WITH_SAM_MAX_MINTS_PER_WALLET_OPTIONS = [
  5
];
const UploadStepInfoTypenames = {
  ReleaseInfoUploadStepInfo: "ReleaseInfoUploadStepInfo",
  MetadataUploadStepInfo: "MetadataUploadStepInfo",
  RewardsUploadStepInfo: "RewardsUploadStepInfo",
  AuctionConfigurationUploadStepInfo: "AuctionConfigurationUploadStepInfo",
  SplitsUploadStepInfo: "SplitsUploadStepInfo",
  ReviewAndDeployUploadStepInfo: "ReviewAndDeployUploadStepInfo"
};
const UploadStepId = {
  Single: {
    [UploadStepInfoTypenames.ReleaseInfoUploadStepInfo]: 1,
    [UploadStepInfoTypenames.MetadataUploadStepInfo]: 2,
    [UploadStepInfoTypenames.RewardsUploadStepInfo]: 3,
    [UploadStepInfoTypenames.AuctionConfigurationUploadStepInfo]: 4,
    [UploadStepInfoTypenames.SplitsUploadStepInfo]: 5,
    [UploadStepInfoTypenames.ReviewAndDeployUploadStepInfo]: 6
  },
  Album: {
    [UploadStepInfoTypenames.ReleaseInfoUploadStepInfo]: 1,
    [UploadStepInfoTypenames.RewardsUploadStepInfo]: 2,
    [UploadStepInfoTypenames.AuctionConfigurationUploadStepInfo]: 3,
    [UploadStepInfoTypenames.SplitsUploadStepInfo]: 4,
    [UploadStepInfoTypenames.ReviewAndDeployUploadStepInfo]: 5
  }
};
const SINGLE_UPLOAD_STEPS = [
  {
    name: UPLOAD_STEP_NAMES.RELEASE_INFO,
    step: UploadStepId.Single.ReleaseInfoUploadStepInfo,
    optional: false
  },
  {
    name: UPLOAD_STEP_NAMES.METADATA,
    step: UploadStepId.Single.MetadataUploadStepInfo,
    optional: true
  },
  {
    name: UPLOAD_STEP_NAMES.REWARDS,
    step: UploadStepId.Single.RewardsUploadStepInfo,
    optional: false
  },
  {
    name: UPLOAD_STEP_NAMES.AUCTION_CONFIGURATION,
    step: UploadStepId.Single.AuctionConfigurationUploadStepInfo,
    optional: false
  },
  {
    name: UPLOAD_STEP_NAMES.SPLITS,
    step: UploadStepId.Single.SplitsUploadStepInfo,
    optional: true
  },
  {
    name: UPLOAD_STEP_NAMES.REVIEW_AND_DEPLOY,
    step: UploadStepId.Single.ReviewAndDeployUploadStepInfo,
    optional: false
  }
];
const ALBUM_UPLOAD_STEPS = [
  {
    name: UPLOAD_STEP_NAMES.ALBUM_INFO,
    step: UploadStepId.Album.ReleaseInfoUploadStepInfo,
    optional: false
  },
  {
    name: UPLOAD_STEP_NAMES.REWARDS,
    step: UploadStepId.Album.RewardsUploadStepInfo,
    optional: false
  },
  {
    name: UPLOAD_STEP_NAMES.AUCTION_CONFIGURATION,
    step: UploadStepId.Album.AuctionConfigurationUploadStepInfo,
    optional: false
  },
  {
    name: UPLOAD_STEP_NAMES.SPLITS,
    step: UploadStepId.Album.SplitsUploadStepInfo,
    optional: true
  },
  {
    name: UPLOAD_STEP_NAMES.REVIEW_AND_DEPLOY,
    step: UploadStepId.Album.ReviewAndDeployUploadStepInfo,
    optional: false
  }
];
const NUM_UPLOAD_STEPS_FOR_RELEASE_TYPE = {
  SINGLE: SINGLE_UPLOAD_STEPS.length,
  ALBUM: ALBUM_UPLOAD_STEPS.length
};
const RELEASE_TYPE_TO_UPLOAD_STEPS = {
  [ReleaseTypeEnum.SINGLE]: SINGLE_UPLOAD_STEPS,
  [ReleaseTypeEnum.ALBUM]: ALBUM_UPLOAD_STEPS,
  [ReleaseTypeEnum.ALBUM_TRACK]: null
};

export { ALBUM_UPLOAD_STEPS, DRAFT_UPDATE_FAILED_DUP_TITLE_MESSAGE, FREE_SALE_MAX_MINTS_PER_WALLET_OPTIONS, MAX_PRESALE_MAX_MINTS_PER_WALLET, MAX_PUBLIC_SALE_MAX_MINTS_PER_WALLET, MIN_PRESALE_MAX_MINTS_PER_WALLET, MIN_PUBLIC_SALE_MAX_MINTS_PER_WALLET, NUM_UPLOAD_STEPS_FOR_RELEASE_TYPE, OPEN_EDITION_MAX_MINTS_PER_WALLET_OPTIONS, PRESALE_MAX_MINTS_PER_WALLET_OPTIONS, PRESALE_OPEN_EDITION_WITH_SAM_MAX_MINTS_PER_WALLET_OPTIONS, PUBLIC_SALE_MAX_MINTS_PER_WALLET_OPTIONS, RELEASE_TYPE_TO_UPLOAD_STEPS, SINGLE_UPLOAD_STEPS, UPLOAD_STEP_NAMES, UploadStepId, UploadStepInfoTypenames };
